import { setIsLoading } from '../../../../../actions/general';
import { callApi } from '../../../../../apiCaller';
import { API_SYSTEM_ADMIN_TEST } from '../../../../../constants';
import { toastError } from '../../../../../utils';

export const SET_ADMIN_TEST_DETAILS = 'setAdminTestDetails';
export const SET_ADMIN_TEST_QUESTIONS = 'setAdminTestQuestions';
export const ADD_ADMIN_TEST_QUESTION = 'addAdminTestQuestion';
export const UPDATE_ADMIN_TEST_QUESTION = 'updateAdminTestQuestion';
export const DELETE_ADMIN_TEST_QUESTION = 'deleteAdminTestQuestion';

export const setAdminTestDetails = (testDetails) => {
     return {
          type: SET_ADMIN_TEST_DETAILS,
          payload: testDetails,
     };
};

export const setAdminTestQuestions = (testQuestions) => {
     return {
          type: SET_ADMIN_TEST_QUESTIONS,
          payload: testQuestions,
     };
};

export const addAdminTestQuestion = (testQuestion) => {
     return {
          type: ADD_ADMIN_TEST_QUESTION,
          payload: testQuestion,
     };
};

export const updateAdminTestQuestion = (testQuestion) => {
     return {
          type: UPDATE_ADMIN_TEST_QUESTION,
          payload: testQuestion,
     };
};

export const deleteAdminTestQuestion = (testQuestionId) => {
     return {
          type: DELETE_ADMIN_TEST_QUESTION,
          payload: testQuestionId,
     };
};

export const fetchAdminTestDetailsRequest = (testId) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SYSTEM_ADMIN_TEST.replace(':id', testId), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               dispatch(setAdminTestDetails(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
